<template>
  <v-row>
    <v-col cols="12" v-for="(item, i) in localMedicalCertificateParent.list" :key="i">
      <MedicalCertificateDocComponent
        :index="i"
        :item="item"
        @set-data="setMedicalCertificate($event, item)"
        @remove="removeMedicalCertificate(item)"
      />
    </v-col>

    <v-col
      cols="12"
      class="d-flex justify-end pt-0"
      v-if="!localMedicalCertificateParent.list.length"
    >
      <v-btn
        color="primary"
        outlined
        rounded
        @click="addMedicalCertificate"
      >
        <v-icon left>
          mdi-plus
        </v-icon>
        Добавить медицинскую справку
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import Title from '@/components/ui/Title'
import MedicalCertificateDocComponent from '@/components/zvp/application-create/medical-certificate-doc/MedicalCertificateDoc'
import {MedicalCertificateParent, MedicalCertificate} from '@/models'
import _cloneDeep from "lodash/cloneDeep";

export default {
  name: "MedicalCertificateDoc",

  components: {
    Title,
    MedicalCertificateDocComponent
  },

  props: {
    item: MedicalCertificateParent
  },

  data: () => ({
    localMedicalCertificateParent: new MedicalCertificateParent(),
  }),

  computed: {},

  methods: {
    addMedicalCertificate() {
      this.localMedicalCertificateParent.list.push(new MedicalCertificate())
    },

    setMedicalCertificate(event, item) {
      item.setProperties(event)
      this.$emit('set-data', this.localMedicalCertificateParent)
    },

    removeMedicalCertificate(item) {
      this.$emit('remove', item)
      //this.localMedicalCertificateParent.remove(item)
    },
  },

  watch: {
    'item.list': {
      immediate: true,
      deep: true,
      handler(value) {
        this.localMedicalCertificateParent = _cloneDeep(this.item)
        if (!value?.length) this.addMedicalCertificate()
      }
    }
  }
}
</script>

<style scoped>
</style>
